export default __webpack_public_path__ + "static/media/ic_eth_40.5e255508.svg";